// @flow
import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  FETCH_STORE_POINTS: `${env.baseApiUrl}/checkout/admin/store-point`,
  FETCH_STORE_REFERREDS: `${env.baseApiUrl}/checkout/admin/store-point/referral`,
  FETCH_STORE_INFO_REFERRED: `${env.baseApiUrl}/usher/store/min-information`,
  REDEEM_STORE_SUBSCRIPTION: `${env.baseApiUrl}/checkout/admin/store-point/redeem`,
  FETCH_REDEEMED_BENEFIT: `${env.baseApiUrl}/checkout/admin/subscription/creation-request`,
});

export const STORE_BENEFITS = Object.freeze({
  MONTHLY_PRO_PLUS_SUBSCRIPTION: 'MONTHLY_PRO_PLUS_SUBSCRIPTION',
});

export type StoreBenefit = $Keys<typeof STORE_BENEFITS>;

export const AVAILABLE_REDEEMS: {
  label: StoreBenefit,
  name: string,
  points: string,
}[] = [
  {
    label: STORE_BENEFITS.MONTHLY_PRO_PLUS_SUBSCRIPTION,
    name: 'Plan mensual',
    points: '40',
  },
];
export type RedeemPointsRequest = {
  benefit: StoreBenefit,
};

export const getStorePointsApi = getCreator(endpoints.FETCH_STORE_POINTS);
export const getStoreReferredsApi = getCreator(endpoints.FETCH_STORE_REFERREDS);
export const getStoreInfoReferredsApi = getCreator(
  endpoints.FETCH_STORE_INFO_REFERRED
);
export const redeemStoreSubscriptionApi = postCreator(
  endpoints.REDEEM_STORE_SUBSCRIPTION
);
export const getRedeemedBenefitApi = getCreator(
  endpoints.FETCH_REDEEMED_BENEFIT
);
